import React, { FC, useMemo } from 'react';
import useEEActive from '../../../hooks/useEEActive';
import ctaTypes from '../../../enums/CTA.enums';
import CTA from '../cta';
import TextComponentDecider from '../TextComponentDecider';
import { HeadingModel } from './model/heading.model';
import { THeadingProps } from './types/heading.types';
import { targetLinkdsk } from '../../../utils/targetDskLink';
import useMediaQuery from '../../../lib/custom-hooks/useMediaQuery';
import { BreakpointsInPx } from '../../../constants/breakpoints.constants';
import { googleClickCtaEvent, googleClickRichTextEvent } from '../../../utils/analytics';
import { getTextType } from '../../../utils/getTextType.utils';

const Heading: FC<THeadingProps> = (props) => {
  const isEE = useEEActive();
  const memoDependencires = props?.modelDependencies || [];
  const model = useMemo(() => new HeadingModel(props, isEE), [...memoDependencires, props, isEE]); // eslint-disable-line
  const {
    extraClassNameLink = '',
    children,
    customTextTitle = false,
    customTextSubtitle = false,
    tag = 'h2',
    useDictionaryFallback = false,
    titleDictionaryKey,
    eyebrowDictionaryKey,
    descriptionDictionaryKey,
  } = props;
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);

  return (
    <div className={'heading'}>
      {(model.eyebrowExistsOrIsEE || useDictionaryFallback) && (
        <TextComponentDecider
          type={getTextType('Text', !model.eyebrow?.value)}
          tag={'span'}
          field={model.eyebrow}
          className="heading__eyebrow"
          editable={model.editable}
          dictionaryKey={eyebrowDictionaryKey}
        />
      )}

      {(model.titleExistsOrIsEE || useDictionaryFallback) && (
        <TextComponentDecider
          type={getTextType(customTextTitle ? 'CustomText' : 'Text', !model.title?.value)}
          tag={tag}
          field={model.title}
          className="heading__title"
          editable={model.editable}
          dictionaryKey={titleDictionaryKey}
        />
      )}
      {(model.subtitleExistsOrIsEE || useDictionaryFallback) && (
        <TextComponentDecider
          type={getTextType(customTextSubtitle ? 'CustomText' : 'RichText', !model.subtitle?.value)}
          tag="div"
          field={model.subtitle}
          className="heading__subtitle rich-text"
          editable={model.editable}
          onClick={(event) => {
            if (props.useAnalytics) {
              googleClickRichTextEvent(event, model.title?.value);
            }
          }}
          dictionaryKey={descriptionDictionaryKey}
        />
      )}
      {!props.hideSecondaryLink && model.isLinkExistsOrIsEE && (
        <span className={`heading__link ${extraClassNameLink}`}>
          <CTA
            type={ctaTypes.secondaryRed}
            field={model.link}
            target={targetLinkdsk(model?.link, isDesktop)}
            onClick={() => {
              if (props.useAnalytics) {
                googleClickCtaEvent('Link', model?.link?.value.text ?? model?.link?.value.title, model.title?.value);
              }
            }}
          />
        </span>
      )}
      {(Boolean(children) || isEE) && <span className="heading__generic-popup">{children}</span>}
    </div>
  );
};
export default React.memo(Heading);
